export default "<br><br><footer class='footer text-center'>&copy; {{footerCompName}}</footer>\n"